import { filterBy,getI18ns } from 'components/hoc/index';
import { ColumnsDropzone } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import { DropTarget } from 'react-dnd';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Enums from 'utils/EnumsManager';
import { notification, Tooltip, Icon } from 'antd';
import OrderModal from '../OrderModal';
import { moveToZone, setActions } from '../../flow/actions';
import { CommonDraggableTag } from '../index';
import AggregateModal from './Modal';

const { FieldTypes, DROPZONES } = Enums;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;

const propTypes = {
  isOver: PropTypes.bool.isRequired,
  filteredData: PropTypes.array.isRequired,
  i18ns: PropTypes.object.isRequired
};

class AggregatesZone extends PureComponent {
  render() {
    const {
      isOver,
      connectDropTarget,
      filteredData,
      selectedCols
    } = this.props;
    const cols = _.filter(selectedCols, c => c && c.belongTo === AGGREGATES);

    const zoneTitle = (
      <div>
        <FormattedMessage id="page.ReportTableSetup.descriptions.aggregates" />
        <Tooltip title={<FormattedMessage id="page.ReportTableSetup.tips.aggregates" />}>
          <Icon type="question-circle" className={classNames('font-sm', 'ml-sm')} />
        </Tooltip>
      </div>
    );

    const zoneAction = (
      <OrderModal />
    );

    return connectDropTarget(
      <div>
        <ColumnsDropzone
          isOver={isOver}
          description={
            <FormattedMessage id="page.ReportTableSetup.descriptions.aggregates" />
          }
          zoneTitle={zoneTitle}
          zoneAction={zoneAction}
        >
          {cols.map((record, i) => (
            <CommonDraggableTag
              key={record.id}
              {...record}
              index={i}
              // WARNING: Because record is an instance, all properties of the instance is accessed by getter, we have to explicit pass all necessary props on the component.
              //          Otherwise will cause issue when DnD internal access on some props.
              id={record.id}
              name={record.name}
              type={record.type}
              label={record.label}
              disabled={record.disabled}
              belongTo={record.belongTo}
              actions={record.actions}
              setActions={this.props.setActions}
              restriction={record.fieldRestricted}
              fieldDeleted={record.fieldDeleted}
            />
          ))}
        </ColumnsDropzone>
        <AggregateModal />
      </div>
    );
  }
}

const spec = {
  drop: (props, monitor, component) => {
    // get item id from drag source
    const { id, belongTo } = monitor.getItem();
    const { selectedCols, i18ns } = props;
    if (_.isArray(selectedCols) && selectedCols.length >= 10 && belongTo !== DROPZONES.AGGREGATES) {
      notification.error({
        duration: 3,
        message: i18ns.totalMax,
      });
    } else {
      props.moveToZone(DROPZONES.AGGREGATES, id);
    }
  }
};
const collect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget(),
  isOver: monitor.isOver()
});
const mapStateToProps = ({ global, reportSetup }) => ({
  lang: global.language,
  data: reportSetup.sider.availableColumns,
  selectedCols: reportSetup.sider.selectedCols,
});
const mapDispatchToProps = {
  moveToZone,
  setActions
};

const enhancers = compose(
  getI18ns({
    totalMax: 'page.ReportFilters.errors.totalMax',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  filterBy('data', record => record.belongTo === DROPZONES.AGGREGATES),
  DropTarget(FieldTypes.NumberInput, spec, collect),
  injectIntl
);

AggregatesZone.propTypes = propTypes;
export default enhancers(AggregatesZone);



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/components/AggregatesZone/index.jsx